import { render, staticRenderFns } from "./SettingsChangePassword.vue?vue&type=template&id=30b8dff2&scoped=true&lang=pug&"
import script from "./SettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./SettingsChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b8dff2",
  null
  
)

export default component.exports